export enum ErrorVariant {
  NotFound = 'not-found',
  LoginFailed = 'login-failed',
  PartnerLoginFailed = 'partner-login-failed',
  AdminLoginFailed = 'admin-login-failed',
  Unauthorized = 'unauthorized',
  PageLoadError = 'page-load-error',
}
